import { useEffect, useMemo, useState } from "react";
import {
    resolveAuditLogWindow,
    type AuditLogCustomWindow,
    type AuditLogPeriod,
    type AuditLogWindow,
} from "./auditLogPresentation";

const RELATIVE_WINDOW_REFRESH_MS = 60_000;

export const useAuditLogWindow = (period: AuditLogPeriod, customWindow: AuditLogCustomWindow): AuditLogWindow => {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        if (period === "all" || period === "custom") {
            return;
        }

        const intervalId = setInterval(() => setNow(new Date()), RELATIVE_WINDOW_REFRESH_MS);

        return () => clearInterval(intervalId);
    }, [period]);

    return useMemo(() => resolveAuditLogWindow(period, now, customWindow), [period, now, customWindow]);
};
